import React, { useContext, useEffect, useState } from "react";
import Header2 from "../../Layout/Header2";
import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import city from "../../Images/Rectangle 1512.png";
import button from "../../Images/Group 1171279371.png";
import magnify from "../../Images/1.png";
import img from "../../Images/Rectangle 1513.png";
import img2 from "../../Images/Rectangle 1513 (1).png";
import img3 from "../../Images/Rectangle 1513 (2).png";

import { useLocation, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
const BlogDetails = () => {
  // const categories = [
  //   "Residential Real Estate",
  //   "Commercial Real Estate",
  //   "Industrial Real Estate",
  //   "Agricultural Real Estate",
  //   "Mixed-Use Real Estate",
  //   "Special-Purpose Real Estate",
  //   "Rental & Investment Properties",
  // ];
  const [toggle, setToggle] = useState({
    toggle01: true,
    toggle02: false,
  });

  const handleToggle = (section) => {
    setToggle({
      toggle01: section === "recent",
      toggle02: section === "categories"
    })
  }
  const [lastThreeBlogs, setLastThreeBlogs] = useState([]);
  const [readMoreBlogContent, setReadMoreBlogContent] = useState(false);
  const [contactUsForm, setContactUsForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
  });
  const location = useLocation();
  let { data } = location.state || {};
  const navigateTo = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await HomeService.getBlogs(3);
        setLastThreeBlogs(res.data);
      } catch (error) {
        console.error("error in fetching Blogs", error);
        toast.error("Error Fetching Blogs!");
      }
    };

    fetchBlogs();
  }, []);

  const dateConvertion = (rawDate) => {
    const stringDate = rawDate.split("T")[0];
    const date = new Date(stringDate);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day with leading zero if needed
      month: "long", // Full month name
      year: "numeric", // Full year
    });
  };

  const handleClickOnSmallBlog = (data) => {
    navigateTo("/blog-details", { state: { data } });
  };

  const handleChange = (e) => {
    setContactUsForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const contactUsFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await HomeService.addContactUs(contactUsForm);
      if (res?.status) {
        toast.success("Enquery Added Successfully!");
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("could not send contact us data!", error);
    }
    setContactUsForm({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
    });
  };

  console.log("KJH103", data);
  const [categories, setCategories] = useState([])
  const getBlogCategories = async () => {
    try {
      const response = await HomeService.getBlogCategoryList();
      console.log("VHI108", response);
      if (response.status) {
        setCategories(response.data)
      }

    } catch (error) {

    }
  }

  useEffect(() => {
    getBlogCategories()
  }, [])

  const listBlogByCategory = (e, categoryId,categoryName) => {
    e.preventDefault()
    navigateTo("/blog", { state: { blogCategory: categoryId, blogCategoryName: categoryName} })
  }

  return (
    <>
      <div className="pricing_plans_container">
        <Header2 />
        <div>
          <h1 className=" about_head">
            Blogs
            <span>
              <img className="img_logo2" src={headlogo} />
            </span>
          </h1>
          <p className="about_head_para">
            Lorem Ipsum placeholder text for use in your graphic, print and web
            layouts, and discover <br /> plugins for your favorite writing,
            design and blogging tools.{" "}
          </p>
        </div>
        <img className="isolation_img_5" src={isolation} />
        <img className="isolation_img_6" src={isolation2} />
        {/* <img className='isolation_img_4' src={isolation3}/> */}
      </div>
      <div className="blog_container">
        <div className="blog_details_Wrapper">
          <div className="blog_details_left">
            {/* <h1>Best Cities for Luxury Living in 2025</h1> */}
            <h1>{data.title}</h1>
            <h6>
              Last updated:{`${dateConvertion(data.createdOn)} By `}
              <span>Winners</span>  | 6 Minutes Read
            </h6>
            <div className="blog_details_img_div">
              <img src={data.image} alt="blog Image" />
            </div>
            <p className="blog_para">
              {!readMoreBlogContent
                ? data.description.slice(0, 1000)
                : data.description}
            </p>
            {/* <p className="blog_para">
              Many desktop publishing packages and web page editors now use
              Lorem Ipsum as their default model text, and a search for 'lorem
              ipsum' will uncover many web sites still in their infancy.{" "}
            </p>
            <p className="blog_para">
              Many desktop publishing packages and web page editors now use
              Lorem Ipsum as their default model text, and a search for 'lorem
              ipsum' will uncover many web sites still in their infancy. Various
              versions have evolved over the years, sometimes by accident,
              sometimes on purpose (injected humour and the like).
            </p>

            <h2>Which One is Right for You?</h2>
            <p className="blog_para">
              There are many variations of passages of Lorem Ipsum available,
              but the majority have suffered alteration in some form, by
              injected humour, or randomised words which don't look even
              slightly believable. If you are going to use a passage of Lorem
              Ipsum, you need to be sure there isn't anything embarrassing
              hidden in the middle of text.{" "}
            </p>

            <h2>Make Your Home Irresistible to Buyers</h2>
            <p className="blog_para">
              All the Lorem Ipsum generators on the Internet tend to repeat
              predefined chunks as necessary, making this the first true
              generator on the Internet. It uses a dictionary of over 200 Latin
              words, combined with a handful of model sentence structures, to
              generate Lorem Ipsum which looks reasonable. The generated Lorem
              Ipsum is therefore always free from repetition, injected humour,
              or non-characteristic words etc.
            </p>
            <p className="blog_para">
              Many desktop publishing packages and web page editors now use
              Lorem Ipsum as their default model text, and a search for 'lorem
              ipsum' will uncover many web sites still in their infancy. Various
              versions have evolved over the years, sometimes by accident,
              sometimes on purpose (injected humour and the like).
            </p>

            <h2>Real Estate Markets to Watch This Year</h2>
            <p className="blog_para">
              Richard McClintock, a Latin professor at Hampden-Sydney College in
              Virginia, looked up one of the more obscure Latin words,
              consectetur, from a Lorem Ipsum passage, and going through the
              cites of the word in classical literature, discovered the
              undoubtable source.
            </p>
            <p className="blog_para">
              Richard McClintock, a Latin professor at Hampden-Sydney College in
              Virginia, looked up one of the more obscure Latin words,
              consectetur, from a Lorem Ipsum passage, and going through the
              cites of the word in classical literature, discovered the
              undoubtable source.
            </p> */}

            {readMoreBlogContent ? (
              <div className="button_wrapper_blog d-flex justify-content-center mt-5">
                <button
                  className="discover_btn_5"
                  onClick={() => {
                    setReadMoreBlogContent(true);
                  }}
                >
                  Read more ...
                </button>
              </div>
            ) : null}
          </div>
          <div className="blog_details_right">
            {/* <div
              style={{
                position: "relative",
              }}
            >
              <input
                className="search_Input"
                placeholder="Search"
                type="text"
              />
              <img
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  width: "15px",
                }}
                src={magnify}
              />
            </div> */}
            <div
              className="pricing_plan_head"
              style={{
                cursor: "pointer",
                marginTop: "20px",
              }}
            >
              <div
                className={
                  toggle.toggle01 ? "montly_head" : "montly_head_not_active"
                }
                onClick={() => handleToggle("recent")}
              >
                Recent Post
              </div>
              <div
                className={
                  toggle.toggle02 ? "montly_head" : "montly_head_not_active"
                }
                onClick={() => handleToggle("categories")}
              >
                Categories
              </div>
            </div>
            {toggle.toggle01 && (
              <div className="recent_post_wrapper">
                <h2>Recent Post</h2>
                {lastThreeBlogs.map((e, i) => {
                  return (
                    <>
                      <div
                        onClick={() => {
                          // data = { ...e };
                          // console.log("data", data);
                          // setReRender(!reRender);
                          handleClickOnSmallBlog(e);
                        }}
                        style={{ cursor: "pointer" }}
                        key={i}
                        className={
                          i == 0 ? "recent_post_div_active" : "recent_post_div"
                        }
                      >
                        <div className="recent_post_img">
                          <img src={e.image} alt="blogs" />
                        </div>
                        <div className="recent_post_details">
                          <p
                            className="blog_para"
                            style={{
                              margin: "0px",
                              marginBottom: "10px",
                            }}
                          >
                            {e.description.slice(0, 50)}
                          </p>
                          <div className="post_by_post_time_wrapper">
                            <div className="post_by">
                              <i class="fa-solid fa-user"></i>
                              <p>Winners</p>
                            </div>

                            <div className="post_by">
                              <i class="fa-regular fa-clock"></i>
                              <p>11 Min</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}

            {toggle.toggle02 && <div className="recent_post_wrapper">
              <h2>Categories</h2>

              <div className="categories-wrapper">
                {categories.map((item, index) => (
                  <p key={index}
                    onClick={(e) => listBlogByCategory(e, item?._id,item?.catName)}
                  >
                    {index + 1}. {item?.catName}
                  </p>
                ))}
              </div>
            </div>}

            <form
              className="recent_post_form_main"
              onSubmit={(e) => {
                contactUsFormSubmit(e);
              }}
            >
              <h3>Contact US</h3>
              <div className="recent_post_form_wrapper">
                <div className="recent_post_input_wrapper">
                  <label>First Name</label>
                  <input
                    name="firstName"
                    placeholder="Enter First Name"
                    type="text"
                    value={contactUsForm.firstName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="recent_post_input_wrapper">
                  <label>Last Name</label>
                  <input
                    name="lastName"
                    placeholder="Enter Last Name"
                    type="text"
                    value={contactUsForm.lastName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="recent_post_input_wrapper">
                  <label>Email Address</label>
                  <input
                    name="email"
                    placeholder="Enter email address"
                    type="text"
                    value={contactUsForm.email}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="recent_post_input_wrapper">
                  <label>Phone Number</label>
                  <input
                    name="phone"
                    defaultValue={"+91-|"}
                    type="text"
                    value={contactUsForm.phone}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>

                <div className="recent_post_input_wrapper2">
                  <label>Address</label>
                  <textarea
                    name="address"
                    placeholder="Type something..."
                    value={contactUsForm.address}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <button className="recent_post_submit_btn" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
